import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";
import { LineChart, Gauge, ShieldCheck, CheckCircle2, GraduationCap } from "lucide-react";

const ARTICLES = [
  { n: 1, icon: LineChart, color: "#635BFF" },
  { n: 2, icon: Gauge, color: "#FF5996" },
  { n: 3, icon: ShieldCheck, color: "#059669" },
];

export default function AcademySection() {
  const { t } = useLang();
  return (
    <section id="academy" className="py-24 bg-white" data-testid="academy-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-center gap-3">
          <GraduationCap size={20} className="text-[#635BFF]" />
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#635BFF]">{t("academy.eyebrow")}</p>
        </div>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0A2540] mt-3 max-w-2xl">
          {t("academy.title")}
        </h2>
        <p className="text-[#425466] mt-4 max-w-2xl">{t("academy.subtitle")}</p>

        <Accordion type="single" collapsible className="mt-12 grid lg:grid-cols-3 gap-6 items-start">
          {ARTICLES.map((a, i) => (
            <AccordionItem
              key={a.n}
              value={`article-${a.n}`}
              data-testid={`academy-item-${i}`}
              className="bg-[#F6F9FC] border border-[#E6EBF1] rounded-2xl px-6 py-2 transition-all duration-300 data-[state=open]:bg-white data-[state=open]:shadow-[0_16px_40px_rgba(10,37,64,0.10)] data-[state=open]:border-[#635BFF]/30 hover:-translate-y-1"
            >
              <AccordionTrigger className="hover:no-underline py-5 text-left">
                <div>
                  <div
                    className="w-11 h-11 rounded-xl flex items-center justify-center mb-4"
                    style={{ background: `${a.color}14`, border: `1px solid ${a.color}33` }}
                  >
                    <a.icon size={20} style={{ color: a.color }} />
                  </div>
                  <h3 className="font-display text-lg font-semibold text-[#0A2540] leading-snug pr-4">
                    {t(`academy.a${a.n}t`)}
                  </h3>
                  <p className="text-sm text-[#425466] mt-2 font-normal leading-relaxed">{t(`academy.a${a.n}lead`)}</p>
                  <span className="inline-block mt-3 text-xs font-semibold" style={{ color: a.color }}>
                    {t("academy.read")} →
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-6">
                <div className="space-y-4 text-sm text-[#425466] leading-relaxed">
                  <p>{t(`academy.a${a.n}p1`)}</p>
                  <p>{t(`academy.a${a.n}p2`)}</p>
                  <p>{t(`academy.a${a.n}p3`)}</p>
                  <ul className="space-y-2 pt-2">
                    {[1, 2, 3].map((b) => (
                      <li key={b} className="flex items-start gap-2.5">
                        <CheckCircle2 size={15} className="mt-0.5 shrink-0" style={{ color: a.color }} />
                        <span className="font-medium text-[#0A2540]">{t(`academy.a${a.n}b${b}`)}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
